import './ccf-whatsApp-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfWhatsAppIconProps extends SvgIconProps {
  fillColor?: string;
}

/**
 * CcfWhatsAppIcon used to disply whats app icon in the contact card panel
 * @param props - CcfWhatsAppIconProps
 * @example -- <CcfWhatsAppIcon />
 */
export function CcfWhatsAppIcon(props: CcfWhatsAppIconProps) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <g id="ic_whatsapp" clipPath="url(#clip-ic_whatsapp)">
        <path
          id="Path_25181"
          data-name="Path 25181"
          d="M447.476,328.326a9.572,9.572,0,0,0-6.88-2.906,9.832,9.832,0,0,0-9.725,9.91,10.037,10.037,0,0,0,1.3,4.955l-1.38,5.136,5.155-1.378a9.575,9.575,0,0,0,4.647,1.206h0a9.833,9.833,0,0,0,9.725-9.911A9.948,9.948,0,0,0,447.476,328.326Zm-6.88,15.248h0a7.959,7.959,0,0,1-4.115-1.149l-.294-.178-3.059.818.817-3.041-.193-.312a8.338,8.338,0,0,1-1.234-4.38,8.085,8.085,0,1,1,8.083,8.242Zm4.434-6.169c-.243-.124-1.438-.723-1.661-.808s-.385-.123-.547.124-.627.808-.769.971-.284.186-.527.062a6.613,6.613,0,0,1-1.954-1.229,7.45,7.45,0,0,1-1.352-1.716c-.142-.248-.015-.38.107-.505s.243-.289.364-.434a1.687,1.687,0,0,0,.243-.413.465.465,0,0,0-.02-.434c-.06-.124-.546-1.343-.749-1.839s-.4-.417-.546-.425-.3-.009-.466-.009a.887.887,0,0,0-.648.31,2.8,2.8,0,0,0-.85,2.066,4.87,4.87,0,0,0,.992,2.562,10.917,10.917,0,0,0,4.15,3.739,13.816,13.816,0,0,0,1.385.523,3.251,3.251,0,0,0,1.53.1,2.5,2.5,0,0,0,1.641-1.177,2.084,2.084,0,0,0,.14-1.178C445.43,337.589,445.274,337.529,445.031,337.4Z"
          transform="translate(-428.556 -323.419)"
          fill={props.fillColor ? props?.fillColor : '#1ec637'}
          fillRule="evenodd"
        />
      </g>
    </SvgIcon>
  );
}

export default CcfWhatsAppIcon;
